export default __webpack_public_path__ + "static/media/V2_Política_Protección_DatosAPP_anapat.ef438e61.pdf";